import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { generatePath, NavLink } from 'react-router-dom';
import { isSuccess, ResourcesItem } from 'redux-and-the-rest';

import { UserModel } from '../../models/userModel';
import { getUser } from '../../redux/reducers/userReducer';
import { ApplicationState } from '../../redux/types';
import { Routes } from '../../routes';
import { isExternalRoute } from '../../utils/Routes';
import { isRegisteredUser } from '../../utils/UserUtils';

import './PrimaryNav.scss';

interface PrimaryNavigationItem {
  title: string;
  route: string;
}

interface Props {
  user: ResourcesItem<UserModel>;
}

const primaryNavigationItems: PrimaryNavigationItem[] = [{
  title: 'Games',
  route: Routes.Islands.Index,
}, {
  title: 'Products',
  route: Routes.Products,
}, {
  title: 'Schools',
  route: Routes.Schools,
}, {
  title: 'Resources',
  route: Routes.Resources,
}, {
  title: 'Devotionals',
  route: Routes.Devotionals,
}];

const PrimaryNav = ({ user }: Props): React.ReactElement => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

  const accountMenuItem: PrimaryNavigationItem = isLoggedIn ? {
    title: 'Account',
    route: Routes.Account.Index,
  } : {
    title: 'Account',
    route: Routes.Session.New,
  };

  const menuItems = [...primaryNavigationItems, accountMenuItem];

  useEffect(() => {
    if (isSuccess(user)) {
      if (isRegisteredUser(user)) {
        setIsLoggedIn(true);
      }
    } else {
      setIsLoggedIn(false);
    }
  }, [user]);

  return (
    <nav className="primary-nav list">
      {menuItems.map(({ title, route }) => {
        /**
         * External routes need to be linked via a raw anchor tag, React Router will not
         * handle this for us automatically.
         */
        if (isExternalRoute(route)) {
          return (
            <a href={route} title={title} className="list-item link" key={title}>
              {title}
            </a>
          );
        }

        return (
          <NavLink
            className="list-item link"
            activeClassName="active"
            key={title}
            to={generatePath(route)}
            title={title}
          >
            {title}
          </NavLink>
        );
      })}
    </nav>
  );
};

const mapReduxStateToProps = ({ users }: ApplicationState) => ({
  user: getUser(users),
});

export default connect(mapReduxStateToProps)(PrimaryNav);
